import AlertBanner from "@/components/AlertBanner";
import { DelinquentModal } from "@/components/Modal";
import { Header, Sidebar, ScrollToTop } from "@/components/Navigation";
import SuperAdminBanner from "@/components/SuperAdminBanner";
import useNavigationMenu from "@/navigation/useNavigationMenu";
import { useUser } from "@/requests/hooks/user";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "flex min-h-screen w-full flex-col bg-white",
    content: "relative flex flex-grow flex-row",
    outletContainer:
      "mx-auto mt-[160px] w-full max-w-lg flex-grow px-20 py-30 sm:mt-0 sm:px-80 sm:py-40",
  },
  variants: {
    isSidebarExpanded: {
      true: {
        outletContainer: "pl-20 sm:pl-80",
      },
      false: {
        outletContainer: "pl-20 sm:pl-[160px]",
      },
    },
  },
});

const AppLayout = () => {
  const { data: user } = useUser();
  const { pathname } = useLocation();
  const navigation = useNavigationMenu();
  const navigate = useNavigate();
  const [showDelinquentModal, setShowDelinquentModal] = useState(false);
  const userHasDelinquentScope = user?.scopes?.includes(
    "DELINQUENT_ROAD_BLOCK",
  );

  useEffect(() => {
    if (userHasDelinquentScope) setShowDelinquentModal(true);
  }, []);

  const closeModal = () => setShowDelinquentModal(false);

  const getInitialSidebarState = () => {
    const isExpanded = localStorage.getItem("isSideBarPermanentlyExpanded");
    if (!isExpanded) return false;

    return JSON.parse(isExpanded);
  };

  const [isSidebarExpanded, setIsSidebarExpanded] = useState<boolean>(
    getInitialSidebarState(),
  );

  useEffect(() => {
    if (!!navigation?.length) {
      if (
        (!pathname?.includes("/settings") || !pathname?.includes("/profile")) &&
        userHasDelinquentScope
      ) {
        navigate("/settings/billing");
      }
    }
  }, [navigation, pathname]);

  const { base, content, outletContainer } = styles({ isSidebarExpanded });

  const toggleSidebar = () => {
    setIsSidebarExpanded(isSidebarExpanded => {
      localStorage.setItem(
        "isSideBarPermanentlyExpanded",
        JSON.stringify(!isSidebarExpanded),
      );

      return !isSidebarExpanded;
    });
  };

  return (
    <div className={base()}>
      <AlertBanner />
      <ScrollToTop />
      <Header />
      <SuperAdminBanner />
      <div className={content()}>
        <Sidebar isExpanded={isSidebarExpanded} toggle={toggleSidebar} />
        <div className={outletContainer()}>
          <Outlet />
        </div>
      </div>
      <DelinquentModal isOpen={showDelinquentModal} closeModal={closeModal} />
    </div>
  );
};

export default AppLayout;
